

import { MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';

@Entity('broadcast_message')
export class BroadcastMessage {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'broadcast_name',
    })
    broadcastName: string;

    @Column('bigint', {
        nullable: false,
        default: 0,
        name: 'total_msg_count',
    })
    totalMsgCount: number;

    @Column("int", {
        nullable: false,
        name: "company_id"
    })
    companyId: number;

    @Column('text', {
        nullable: false,
        name: 'message',
    })
    message: string;

    @Column('longblob', {
        nullable: true,
        name: 'image',
    })
    image: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'message_type',
    })
    messageType: MessageTypeEnum;

    @Column('tinyint', {
        nullable: false,
        name: 'priority',
    })
    priority: PriorityEnum;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'template_name',
    })
    templateName: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'template_language',
    })
    templateLanguage: string;

    @Column('json', {
        nullable: false,
        name: 'message_params',
    })
    messageParams: JSON;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column("varchar", {
        nullable: true,
        length: 250,
        name: "file_path"
      })
      filePath: string;

      @Column("varchar", {
        nullable: true,
        length: 250,
        name: "file_name"
      })
      fileName: string;
}

